<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-10-13 13:45:11
 * @LastEditors: WangYuhan
-->
<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo1 :collapse="isCollapse" />
    <!--    <logo1 :collapse="isCollapse" />-->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :active-text-color="variables.menuActiveText"
        :background-color="variables.menuBg"
        :collapse="isCollapse"
        :collapse-transition="false"
        :default-active="activeMenu"
        :text-color="variables.menuText"
        :unique-opened="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :base-path="route.path"
          :item="route"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import logo1 from './Logo1';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';

export default {
  components: { SidebarItem, Logo, logo1 },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    activeOpen() {
      return this.$store.state.settings.menuOpen;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
